<template>
    <div v-if="products.length > 0" class="mb-4">
        <SectionTitle :title="$t(title)"/>
        <div class="row mt-2 mt-md-4 gy-4">
            <div
                v-for="product in products"
                :key="product.id"
                class="col-6 mb-4 pb-2 pb-sm-0"
            >
                <ProductThumbSmall :product="product" />
            </div>
        </div>
    </div>
</template>

<script>

import ProductThumbSmall from "~/components/Product/Thumbs/ProductThumbSmall.vue";
import SectionTitle from "~/components/Product/SectionTitle.vue";

export default {
    components: {
        SectionTitle,
        ProductThumbSmall,
    },
    props: {
        products: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
};
</script>
